// HighlightedDescription.tsx
import React from "react";

interface Props {
  text: string;
  highlight: string;
}

export default function HighlightText({ text, highlight }: Props) {
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <strong key={index}>{part}</strong>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  );
}
